import { useGamesStore } from '../../store';

export const useGetFavoritesDataByEntityName = (
  favoritesRequestEntityName: string
) => {
  return useGamesStore((store) => store.favorites[favoritesRequestEntityName]);
};
